const statuses = {
    ACTIVE: 'active',
    SUSPENDED: 'suspended'
};

export default statuses;
